import router from "@/router";

export default (to, from, next) => {
  // If the user is authenticated, continue with the route
  const authInfo = JSON.parse(window.localStorage.getItem("auth"));
  if (authInfo && authInfo.isAuthenticated) {
    return next();
  }
  // Otherwise, log in
  router.push("/v2/auth/login");
};
